<template>
  <div>
    <!--检索-->
    <el-row>
      <el-col>
        <el-form :inline="true" :model="requestData" label-width="120px" style="text-align: right">
          <el-form-item>
            <el-select clearable placeholder="请选择商品类型" v-model="itemType" size="medium" @change="selectChange">
              <el-option v-for="item in selectOptions.itemType" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input clearable size="medium" placeholder="根据商品名称进行搜索" v-model="searchText">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!--表格数据-->
    <el-table v-if="tableData" :data="tableData" stripe style="width: 100%; margin-top: 20px;">
      <el-table-column label="名称">
        <template slot-scope="scope">
          {{scope.row[itemInfo.titleField]}}
        </template>

      </el-table-column>

      <el-table-column label="商品类型">
        <template slot-scope="scope">
          {{transformItem(itemType, 'itemType')}}
        </template>

      </el-table-column>

      <el-table-column width="100" label="价格">
        <template slot-scope="scope">
          {{scope.row[itemInfo.priceField]}}
        </template>
      </el-table-column>

      <el-table-column prop="status" width="60" label="状态">
        <template slot-scope="scope">
          {{transformItem(scope.row.status, 'status')}}
        </template>
      </el-table-column>

      <el-table-column prop="" label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="select(scope.row)">选取</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tableData" class="pagination-wrapper">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="requestData.count" layout="total, prev, pager, next" :total="totalNumber">
      </el-pagination>
    </div>
    <el-row type="flex" justify="center">
      <div class="bottom-btn-box">
        <el-button class="btn-long" type="primary" @click="closeDialog">关闭</el-button>
      </div>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import Util from "@/js/util";

export default {
  data() {
    return {
      searchText: "",
      // 表格数据 & 翻页
      tableData: null,
      totalNumber: null,
      currentPage: 1,
      itemType: 1,
      requestData: {
        // 翻页参数
        offset: 0,
        count: 5
      },
      itemInfo: {
        url: "wdzg/b/cms/commerce/item/list", // 请求地址
        resultArrayName: "item_list", // 返回的数据对象名称
        searchField: "name_like", // 标题搜索字段
        priceField: "promotion_price", // 价格字段
        titleField: "name", // 标题字段
        params: {
          // 默认请求参数
          status: 1
        }
      },
      selectOptions: {
        itemType: [
          { value: 1, text: "普通商品" },
          { value: 2, text: "拼团商品" },
          { value: 3, text: "砍价商品" }
        ],
        status: [{ value: 1, text: "上架" }, { value: 2, text: "下架" }]
      }
    };
  },
  created() {
    this.request();
  },
  methods: {
    request() {
      this.requestData[this.itemInfo.searchField] = this.searchText;
      Object.assign(this.requestData, this.itemInfo.params);
      lib.api.get({
        api: this.itemInfo.url,
        data: this.requestData,
        success: data => {
          data.data[this.itemInfo.resultArrayName].map(val => {
            val[this.itemInfo.priceField] = Util.filterPrice(
              val[this.itemInfo.priceField]
            );
          });
          this.tableData = data.data[this.itemInfo.resultArrayName];
          this.totalNumber = data.data.total_count;
        },
        error: data => {
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {}
      });
    },
    search() {
      this.request();
    },
    selectChange(val) {
      switch (val) {
        case 1:
          this.itemInfo = {
            url: "wdzg/b/cms/commerce/item/list",
            searchField: "name_like",
            priceField: "promotion_price",
            titleField: "name",
            resultArrayName: "item_list",
            params: {
              status: 1
            }
          };
          break;
        case 2:
          this.itemInfo = {
            url: "wdzg/b/form_group/activity/list",
            searchField: "name",
            priceField: "price",
            titleField: "title",
            resultArrayName: "form_group_activity_list",
            params: {
              item_type: 1,
              lifecycle: 5
            }
          };
          break;
        case 3:
          this.itemInfo = {
            url: "wdzg/b/bargain/activity/list",
            searchField: "name",
            priceField: "price",
            titleField: "name",
            resultArrayName: "bargain_activity_list",
            params: {
              item_type: 1,
              life_cycle: 5
            }
          };
          break;
      }
      this.request();
    },
    select(row) {
      row.itemType = this.itemType;
      this.$emit("select", row);
    },
    transformItem(val, field) {
      let txt = "";
      this.selectOptions[field].forEach(item => {
        if (item.value === val) {
          txt = item.text;
        }
      });
      return txt;
    },
    handleCurrentChange(val) {
      this.requestData.offset = this.requestData.count * (val - 1) || 0;
      this.request();
    },
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="sass">
</style>